import React, { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import { toast } from "sonner";
import { useAuth } from "../lib/AuthContext";

export default function Settings() {
  const { fxRate } = useAuth();
  const [f, setF] = useState({
    company_name: "", company_address: "", company_email: "",
    company_phone: "", default_currency: "USD",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setF({ ...f, ...r.data }));
    // eslint-disable-next-line
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/settings", f);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-widest text-[var(--text-2)] mb-2">Administration</div>
        <h1 className="font-serif text-4xl">System Settings</h1>
      </div>

      <form onSubmit={save} className="card-sharp p-8 space-y-6" data-testid="settings-form">
        <div className="grid grid-cols-2 gap-4">
          <Field label="Company name">
            <Input value={f.company_name} onChange={(e) => setF({ ...f, company_name: e.target.value })} className="rounded-none" data-testid="setting-company-name" />
          </Field>
          <Field label="Default currency">
            <Select value={f.default_currency} onValueChange={(v) => setF({ ...f, default_currency: v })}>
              <SelectTrigger className="rounded-none" data-testid="setting-currency"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="USD">USD</SelectItem>
                <SelectItem value="EUR">EUR</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label="Company email">
            <Input value={f.company_email} onChange={(e) => setF({ ...f, company_email: e.target.value })} className="rounded-none" data-testid="setting-email" />
          </Field>
          <Field label="Company phone / WhatsApp">
            <Input value={f.company_phone} onChange={(e) => setF({ ...f, company_phone: e.target.value })} className="rounded-none" data-testid="setting-phone" />
          </Field>
          <div className="col-span-2">
            <Field label="Company address">
              <Input value={f.company_address} onChange={(e) => setF({ ...f, company_address: e.target.value })} className="rounded-none" data-testid="setting-address" />
            </Field>
          </div>
        </div>

        <div className="rule" />

        <div className="text-sm text-[var(--text-2)]">
          <div className="ledger-head mb-1">Live FX rate</div>
          <div className="mono">1 USD = {fxRate.toFixed(4)} EUR · updated hourly from frankfurter.dev</div>
        </div>

        <Button type="submit" disabled={saving} className="rounded-none bg-[var(--primary)] hover:bg-[var(--primary)]/90 text-white" data-testid="settings-save">
          {saving ? "Saving…" : "Save settings"}
        </Button>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-widest">{label}</Label>
      {children}
    </div>
  );
}
